import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  BOOK_LIST_TYPES,
  BUTTON_TYPE,
  CARD_SIZES,
  COLORS,
  DIVIDER_SIZE,
} from '@helpers/constants'
import BookCard from '@components/BookCard'
import GridColumns from '@components/GridColumns'
import { useResponsive } from '@hooks/useResponsive'
import Divider from '@components/Divider'
import Button from '@components/Button'
import { anySectionHasQuizExams } from '@helpers/exams'

const BookList = (props) => {
  const { items, type, rowLimit = false } = props

  const { breakpoints } = useResponsive()
  const [showAll, setShowAll] = useState(!rowLimit)
  const cols = (() => {
    if (breakpoints.mobile) return 1
    if (breakpoints.tablet) return 2
    if (breakpoints.wide) return 3
    return 4
  })()

  return (
    <div className={'w-full'}>
      <GridColumns cols={cols}>
        {(rowLimit && !showAll ? items.slice(0, cols * rowLimit) : items).map(
          (book) => {
            const hasQuizExams = anySectionHasQuizExams(book.sections)

            return (
              <BookCard
                listType={type}
                key={'book' + book.id}
                book={book}
                size={CARD_SIZES.LARGE}
                hasQuizExams={hasQuizExams}
              />
            )
          }
        )}
      </GridColumns>

      {!showAll && items.length > rowLimit * cols && (
        <>
          <Divider size={DIVIDER_SIZE.SMALL} />

          <div className={'flex justify-end'}>
            <Button
              handleClick={() => {
                setShowAll(true)
              }}
              type={BUTTON_TYPE.PRIMARY}
              textColor={COLORS.BLACK.TEXT}
              backgroundColor={COLORS.SECONDARY_GREEN.BACKGROUND}
              icon={'ChevronDown'}
              iconRight
            >
              Visa alla
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

BookList.propTypes = {
  items: PropTypes.array,
  type: PropTypes.oneOf(Object.values(BOOK_LIST_TYPES)),
}

export default BookList
